<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :disabled='disabled || readonly'
    transition="scale-transition"
    offset-y
    min-width="290px"
    >
    <template v-slot:activator='{ on, attrs }'>
      <v-text-field
        v-model='formattedDate'
        v-on='on'
        v-bind='attrs'
        :class="slim ? 'body-2' : ''"
        :label='label'
        :solo="slim ? true : false"
        :flat="slim ? true : false"
        :dense="slim ? true : false"
        :prepend-icon="slim ? '' : prependIcon"
        :single-line="slim ? true : false"
        :hide-details="slim ? true : false"
        :clearable="!slim && !removeClearOption && !filled"
        @click:clear="clearDate"
        readonly
        :disabled='disabled'
        :rules='required ? [rules.required] : []'
        :hint='hint'
        :persistent-hint='persistentHint'
        :filled='filled'
      />
    </template>
    <v-date-picker
      v-model='dt'
      :min='min'
      :max='max'
      no-title
      @input='updateDate'
      @change='$emit("change")'
    />
  </v-menu>
</template>

<script>
import moment from 'moment';
import formRules from '@/mixins/formRules';

export default {
  name: 'wc-datepicker',
  mixins: [formRules],
  props: {
    label: String,
    value: String,
    max: String,
    min: String,
    removeClearOption: {
      type: Boolean,
      required: false,
      default: false
    },
    defaultToday: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    slim: {
      required: false,
      type: Boolean,
      default: false
    },
    hint: {
      required: false,
      type: String,
    },
    prependIcon: {
      required: false,
      type: String,
      default: "mdi-calendar"
    },
    persistentHint: {
      required: false,
      type: Boolean,
      default: false
    },
    readonly: {
      required: false,
      type: Boolean,
      default: false
    },
    filled: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      menu: false,
      dt: null
    }
  },
  watch: {
    value: function () {
      this.dt = this.value;
    }
  },
  mounted () {
    if (this.defaultToday && this.value === null) {
      this.dt = moment().format('YYYY-MM-DD');
    } else {
      this.dt = this.value;
    }
  },
  computed: {
    formattedDate: {
      get: function () {
        return this.formatDate(this.dt);
      },
      set: function (newValue) {
        this.dt = newValue;
      } 
    }
  },
  methods: {
    updateDate () {
      this.menu = false;
      this.$emit('input', this.dt);
    },
    clearDate () {
      this.dt = null;
      this.$emit('input', this.dt);
      this.$emit('change');
    },
    formatDate (date) {
      if (!date) { return null }
      return moment(date).format('MMMM D, YYYY')
    }
  }
}
</script>
